module.exports = new __parcel__URL__("battlepass_success_text.fdc49e0f.png").toString();